import { render, staticRenderFns } from "./NotificationContainer.vue?vue&type=template&id=cd78e31e&scoped=true&"
import script from "./NotificationContainer.vue?vue&type=script&lang=js&"
export * from "./NotificationContainer.vue?vue&type=script&lang=js&"
import style0 from "./NotificationContainer.vue?vue&type=style&index=0&id=cd78e31e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd78e31e",
  null
  
)

export default component.exports